// new V
import React, { Component, useState, useEffect, useRef } from "react"
import VgLogo from "../../assets/images/gallery-placeholders/videoGameDesign1.jpg"
import FandALogo from './../../assets/images/gallery-placeholders/film-and-animation.jpg'
import { Link, Location } from "@reach/router"
import { GalleryContext } from "./gallery-context"

export class GalleryCard extends Component {
  state = {
    work: {},
    students: [],
  }

  // adding context here! 4/3
  static contextType = GalleryContext;

  extractExcerpt = (html) => {
    const text = html.replace(/<[^>]*>/g, ''); // Strip out HTML tags
    return `${text.slice(0, 50)}...`; // Return sliced excerpt
  }

  getStudents = work => {
    let winners = [work.personName].concat(work.collaborators)
    this.setState({ students: winners })
  }

  componentDidMount() {
    if (!this.props.work || !this.props.work.id) {
      return;
    }


    if (!this.props.work || !this.props.work.id) {
      return;
    }
    
    const workId = String(this.props.work.id);

    const { fetchSingleWork, works } = this.context;
    
    // Only fetch if we don't already have it
    if (!works[workId]) {
      fetchSingleWork(workId);
    } else {
      // If we already have the work in context, use it directly
      this.setState({
        work: works[workId]
      }, () => {
        this.getStudents(this.state.work);
      });
    }
  }

  // NEW
  componentDidUpdate(prevProps, prevState) {
    const workId = String(this.props.work.id);
    const { works } = this.context;
    
    // Check if the work data is now available in context but wasn't before
    if (works[workId] && (!prevState.work || !prevState.work.id)) {
      this.setState({
        work: works[workId]
      }, () => {
        this.getStudents(this.state.work);
      });
    }
  }


  render() {
    const workId = String(this.props.work.id);
    const { works, selectWork } = this.context;
    const workData = this.state.work.id ? this.state.work : (works[workId] || this.props.work);

    return (
      <Location>
        {({ location }) => (
          <div>
            {this.props.work.assetType == "video" ? (
              <li className="gallery-art">
                <div className="video-content-box">
                  <Link
                    state={{
                      oldLocation: JSON.parse(JSON.stringify(location)),
                      title: this.props.work.title,
                      students: this.state.students,
                      work: workData // changed from: this.state.work
                    }}
                    to={"/gallery/" + this.props.work.id}
                    onClick={() => selectWork(workId)}
                  >
                    <img
                      src={this.props.work.thumbUrl}
                      alt={`${this.props.work.title} by ${this.props.work.personName}`}
                    />
                    <span className="overlay">
                      <span>{this.props.work.personName}</span>
                    </span>
                  </Link>
                </div>
              </li>
            ) : this.props.work.categoryName == "Video Game Design" ? (
              <li className="gallery-art">
                <div className="gallery-content-box">
                  <Link
                    state={{
                      oldLocation: JSON.parse(JSON.stringify(location)),
                      title: this.props.work.title,
                      students: this.state.students,
                      work: workData // changed this.state.work,
                    }}
                    to={"/gallery/" + this.props.work.id}
                  >
                    <img
                      src={VgLogo}
                      alt={`${this.props.work.title} by ${this.props.work.personName}`}
                    />
                    <span className="overlay">
                      <span>{this.props.work.personName}</span>
                    </span>
                  </Link>
                </div>
              </li>
            ) : this.props.work.categoryName === "Film & Animation" ? (
              <li className="gallery-art">
                <div className="gallery-content-box">
                  <Link
                    state={{
                      oldLocation: JSON.parse(JSON.stringify(location)),
                      title: this.props.work.title,
                      students: this.state.students,
                      work: workData // this.state.work,
                    }}
                    to={"/gallery/" + this.props.work.id}
                  >
                    <img
                      src={FandALogo}
                      alt={`${this.props.work.title} by ${this.props.work.personName}`}
                    />
                    <span className="overlay">
                      <span>{this.props.work.personName}</span>
                    </span>
                  </Link>
                </div>
              </li>
            ) : this.props.work.isArt == true || this.props.work.isFutureNew ? (
              <li className="gallery-art">
                <div className="gallery-content-box">
                  <Link
                    state={{
                      oldLocation: JSON.parse(JSON.stringify(location)),
                      title: this.props.work.title,
                      students: this.state.students,
                      work: workData // this.state.work,
                    }}
                    to={"/gallery/" + this.props.work.id}
                  >
                    <img
                      src={
                        (this.props.work?.isPortfolio &&
                        Array.isArray(this.props.work.portfolioWorks) &&
                        this.props.work.portfolioWorks.length > 0)
                          ? this.props.work.portfolioWorks[0]?.thumbUrlXLarge || this.props.work.portfolioWorks[0]?.assetUrlXLarge
                          : this.props.work?.thumbUrl
                      }
                      alt={`${this.props.work.title} by ${this.props.work.personName}`}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = FandALogo; 
                      }}
                    />
                    <span className="overlay">
                      <span>{this.props.work.personName}</span>
                    </span>
                  </Link>
                </div>
              </li>
              ) : this.props.work.isWriting && this.props.work.isFutureNew ? (
              <li className="gallery-art">
                <div className="gallery-content-box">
                  <Link
                    state={{
                      oldLocation: JSON.parse(JSON.stringify(location)),
                      title: this.props.work.title,
                      students: this.state.students,
                      work: workData // this.state.work,
                    }}
                    to={"/gallery/" + this.props.work.id}
                  >
                    <img
                      src={this.props.work.thumbUrl}
                      alt={`${this.props.work.title} by ${this.props.work.personName}`}
                    />
                    <span className="overlay">
                      <span>{this.props.work.personName}</span>
                    </span>
                  </Link>
                </div>
              </li>
            ) : (
              <li className="gallery-writing">
                <Link
                  state={{
                    oldLocation: JSON.parse(JSON.stringify(location)),
                    title: this.props.work.title,
                    students: this.state.students,
                    work: workData // this.state.work,
                  }}
                  to={"/gallery/" + this.props.work.id}
                >
                  <span
                    className="text"
                    style={{ backgroundColor: this.props.writingColor }}
                  >
                    <div style={{ position: "absolute", top: "0", left: "0" }}>
                    {this.props.work && this.props.work.isPortfolio && this.props.work.portfolioWorks && this.props.work.portfolioWorks.length > 0 
                    ? this.extractExcerpt(this.props.work.portfolioWorks[0].excerpt) 
                    : this.props.work.excerpt}
                    </div>
                    <span
                      style={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        width: "100%",
                        height: "100%",
                        zIndex: 0,
                        background: `-moz-linear-gradient(90deg, rgba(255,255,255,0) 0%, ${this.props.writingColor} 82%)`,
                        background: `-webkit-linear-gradient(90deg, rgba(255,255,255,0) 0%, ${this.props.writingColor}82%)`,
                        background: `linear-gradient(90deg, rgba(255,255,255,0) 0%, ${this.props.writingColor} 82%)`,
                      }}
                    ></span>
                  </span>
                  <span className="overlay">
                    <span>{this.props.work.personName}</span>
                  </span>
                </Link>
              </li>
            )}
          </div>
        )}
      </Location>
    )
  }
}

GalleryCard.contextType = GalleryContext;

export default GalleryCard
